import { useShallow } from 'zustand/shallow';
import { useFirebaseStore } from '@/stores/useFirebaseStore';

export function useEnableAds() {
  const enableAds = useFirebaseStore(
    useShallow((state) => state.remoteConfig.eggs_vault_on),
  );

  return enableAds === '1';
}

export function useShowAds() {
  const [showBanner, enableAds] = useFirebaseStore(
    useShallow((state) => [
      state.remoteConfig.eggs_vault_banner_on,
      state.remoteConfig.eggs_vault_on,
    ]),
  );

  return showBanner === '1' && enableAds === '1';
}
